<template>
  <div class="l-row--t64 l-row--t128l module">
		<div class="g-row s--h-end triple-device">
			<div class="g-col--5 g-col--4l g-col--halfs triple-device__item-wrap" :class="{'s--none-mo': !checkDisplay(data.target.items[0].src)}">
				<Device class="c-dvc--triple i--item-1 triple-device__item" :noSrcBoxDisplay="checkDisplay(data.target.items[0].src)" :notch="data.target.notch == 1 ? true : false" :target="data.target.items[0]" />
			</div>
			<div class="g-col--5 g-col--4l g-col--halfs triple-device__item-wrap" :class="{'s--none-mo': !checkDisplay(data.target.items[1].src)}">
				<Device class="c-dvc--triple i--item-2 triple-device__item" :noSrcBoxDisplay="checkDisplay(data.target.items[1].src)" :notch="data.target.notch == 1 ? true : false" :target="data.target.items[1]" />
			</div>
			<div class="g-col--5 g-col--4l g-col--halfs l-mdl--64s triple-device__item-wrap" :class="{'s--none-mo': !checkDisplay(data.target.items[2].src)}">
				<Device class="c-dvc--triple i--item-3 triple-device__item" :noSrcBoxDisplay="checkDisplay(data.target.items[2].src)" :notch="data.target.notch == 1 ? true : false" :target="data.target.items[2]" />
			</div>
		</div>
	</div>
</template>

<script>
import * as $ from "fxdom";
import * as _ from "fxjs";
import { computed, ref, reactive, useStore } from "@/helper/vue.js";
import Picture from "@/parts/picture/PictureView.vue";
import Device from "@/parts/work-view/_Device.vue";
import { useRoute } from 'vue-router';

export default {
  props: ["idx", "bindRoot"],
	components: {
		Picture,
		Device
	},
  setup(props) {
    const { get } = useStore();
		const self = ref();
		const route = useRoute();
		const data = reactive({
			target: computed(() => get["from"](`${props.bindRoot}.modules.${props.idx}`)),
		});

		const checkDisplay = (src) => {
			return route.name == "project" && src == "" ? false : true
		}

    return {
			self,
			data,
			checkDisplay
    };
  },
};
</script>

<style scoped lang="scss">
.triple-device {
	.w1600__ & {
		justify-content: space-around;
		.c-dvc {
			margin-right: 42em;
			margin-left: 42em;
		}
	}
	.__w600 & {
		&__item-wrap {
			&:last-child {
				.c-dvc {
					.__w600 & {
						// margin-top: 64em;
					}
				}
			}
		}
	}
}
</style>